import React, { useState } from 'react';
import { toast } from 'react-toastify';

import ConfirmModal from 'components/Modals/confirmModal';
import { ApiMethodHeader } from './styles';
import { IconButtonContainer, ButtonIcon } from 'components/HeaderFreecode/styles';

export default function ApiMethodDisplay({ index, apiMethod, apiType, onClickEdit }) {
  const [viewDeleteModal, setViewDeletemodal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteThisMethod = () => {
    setDeleting(true);
    // TODO Delete the api method, remove from context once this function is done
    setTimeout(() => setDeleting(false), 1000);
    console.log(`Should delete ${apiType} api with index ${index}`);
    toast.error('API deletion Not Implemented!');
  };

  return (
    <ApiMethodHeader canOpen onClick={onClickEdit}>
      {apiMethod.header ?? apiMethod.name}
      <IconButtonContainer
        onClick={(e) => {
          e.stopPropagation();
          setViewDeletemodal(true);
        }}
      >
        <ButtonIcon icon="fa fa-trash" />
      </IconButtonContainer>
      {viewDeleteModal && (
        <ConfirmModal
          title={`Delete "${apiMethod.header ?? apiMethod.name}"`}
          text="Are you sure you want to delete this API?"
          onCancel={() => !deleting && setViewDeletemodal(false)}
          onConfirm={deleteThisMethod}
          loading={deleting}
        />
      )}
    </ApiMethodHeader>
  );
}
